import { expand } from 'uri-template-lite';
import { apiClient } from '../../common/ApiClient';
import { Page } from '../../common/queryClient';
import { createApiQueryHook } from '../../common/queryClient/createApiQueryHook';
import { InputDataDetailsKey, InputDataDetailsType } from '../schema/types';
import { InputDataUrl } from './InputDataUrl';
import { InputDataDetailsSchema } from '../schema/InputDataDetailsSchema';

const queryKey = ['useInputDataDetailsQuery'] as const;

const getInputDataDetails = (params?: InputDataDetailsKey) =>
  apiClient
    .get<
      Page<InputDataDetailsType>
    >(expand(InputDataUrl.INPUT_DATA_DETAILS, params))
    .then((response) => InputDataDetailsSchema.parse(response.data));

export const useInputDataDetailsQuery = createApiQueryHook(
  queryKey,
  getInputDataDetails,
);
